import React from 'react';
import { useSelector } from 'react-redux';
import styles from '../styles/SiteTransferNotice.module.css';

const SiteTransferNotice = () => {
  const user = useSelector((state) => state.user.user);

  const handleTransferClick = () => {
    const userToken = user?.userToken || localStorage.getItem('userToken');
    const targetUrl = userToken 
      ? `https://aimonkey.plus?userToken=${userToken}`
      : 'https://aimonkey.plus';
    window.open(targetUrl, '_blank');
  };

  return (
    <div className={styles.siteTransferNotice}>
      <div className={styles.transferBackground}>
        <div className={styles.transferPattern}></div>
      </div>
      <div className={styles.transferContent}>
        <div className={styles.transferHeader}>
        </div>

        {/* 重要通知区域 */}
        <div className={styles.urgentNotice}>
          <div className={styles.urgentHeader}>
            <i className="fas fa-exclamation-triangle"></i>
            <span>⚠️ 重要通知 ⚠️</span>
            <i className="fas fa-exclamation-triangle"></i>
          </div>

          {/* 重要通知标题下方的访问按钮 */}
          <div className={styles.urgentActionSection}>
            <button
              className={styles.urgentTransferButton}
              onClick={handleTransferClick}
            >
              <i className="fas fa-rocket"></i>
              访问新域名
            </button>
          </div>

          <div className={styles.urgentContent}>
            <div className={styles.urgentItem}>
              <i className="fas fa-calendar-times"></i>
              <span><strong>老版本UI将于12月份更新UI</strong>，请大家尽快前往新域名使用新版本！</span>
            </div>
            <div className={styles.urgentItem}>
              <i className="fas fa-lock"></i>
              <span><strong>请手机登录用户尽快设置自己的登录密码</strong>，手机号将不再提供验证码登录功能！</span>
            </div>
            <div className={styles.urgentItem}>
              <i className="fas fa-star"></i>
              <span><strong>新域名已经支持 Gemini 的使用</strong>，体验更强大的AI能力！</span>
            </div>
          </div>
        </div>

        <div className={styles.transferDetails}>
          <div className={styles.singleColumn}>
            <h3>📢 通知说明：</h3>
            <ul>
              <li>🎉 新域名 aimonkey.plus 已正常使用，功能更多，UI更好</li>
              <li>✅ 新老域名同时运行，为大家提供服务</li>
            </ul>
          </div>
        </div>

        <div className={styles.transferActions}>
          <button
            className={styles.transferButton}
            onClick={handleTransferClick}
          >
            <i className="fas fa-external-link-alt"></i>
            访问新域名
          </button>
        </div>
      </div>
    </div>
  );
};

export default SiteTransferNotice;